module.exports = __webpack_public_path__ + "static/media/dca_brainslug.7dff726b.jpg";